import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetPDFAccountBalanceCtrl = function (fn, er, branchCode, date, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
		responseType: 'blob'
	};
	var data = {
		branchCode: branchCode === 'Tutti' ? "" : branchCode,
		date: date
	};

	axios
		.post(ApiConfig.url.GET_PDF_ACCOUNT_BALANCE, data, config)
		.then(function (result) {
			fn(result.data)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetPDFAccountBalanceCtrl };